"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalSidebarContainer = void 0;
const react_1 = __importDefault(require("react"));
require("./modal-sidebar-container.scss");
const ModalSidebarContainer = ({ children, }) => {
    return react_1.default.createElement("div", { className: 'ds-modal-sidebar-container' }, children);
};
exports.ModalSidebarContainer = ModalSidebarContainer;
